import {
  GROUPING_DONE_FAILED,
  GROUPING_DONE_REQUEST,
  GROUPING_DONE_SUCCESS,
} from "app/redux/actions/Factory/Grouping/groupingDone/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const groupingDoneReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case GROUPING_DONE_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case GROUPING_DONE_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case GROUPING_DONE_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
